import { MatMenuModule } from '@angular/material/menu';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableModule,
} from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';

export const IMPORTS_MATERIAL = [
  MatBadgeModule,
  MatButton,
  MatCell,
  MatCheckbox,
  MatColumnDef,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
  MatFormField,
  MatHeaderCell,
  MatHeaderRow,
  MatIcon,
  MatIconButton,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatMomentDateModule,
  MatPaginator,
  MatProgressSpinner,
  MatRow,
  MatSelectModule,
  MatSort,
  MatSortHeader,
  MatTable,
  MatTableModule,
  MatTooltip,
];
